import { TabsContentProfile } from "../../components";
import {
  getTabItemsProfileConfig,
  TAB_ITEMS_PROFILE,
  TAB_ITEMS_PROFILE_CASE
} from "../../consts";
import { useAuthStore } from "../../stores";
import type { TabItemsConfigProfile, TabItemsProfile, UserAchievement } from "../../types";


export function filterTabTypes({
  onboarding,
  onboardingCapability,
  onboardingExecutiveJob,
  onboardingPersonalJob,
  tabItems
} : {
      onboarding:boolean,
      onboardingExecutiveJob:boolean,
      onboardingPersonalJob:boolean,
      onboardingCapability:boolean,
      tabItems:TabItemsConfigProfile
  }) {

  return tabItems.flatMap((tab: "EXTERNAL_TRAINING" | "GOALS" | "SECTOR" | "KNOWLEDGE" | "PREFERENCES")=> {
    if (tab === TAB_ITEMS_PROFILE.GOALS) {
      return [tab];
    }
    else if(onboarding
      && (
        (tab === TAB_ITEMS_PROFILE.SECTOR) || (tab === TAB_ITEMS_PROFILE.KNOWLEDGE &&
          (onboardingExecutiveJob || onboardingCapability || onboardingPersonalJob)) ||
      (tab === TAB_ITEMS_PROFILE.PREFERENCES)
      ) ){
      return [tab];
    }
    else {
      return [];
    }
  }) ?? [];
}

export function getTabsProfile({
  onboarding,
  onboardingCapability,
  onboardingExecutiveJob,
  onboardingPersonalJob,
  learnerAchievements=[]
} : {
      onboarding:boolean,
      onboardingExecutiveJob:boolean,
      onboardingPersonalJob:boolean,
      onboardingCapability:boolean,
      learnerAchievements: UserAchievement[]
  }){
  const smartConfiguration = useAuthStore.getState().smartConfiguration;
  const isSimpleOnboarding = onboarding && !onboardingExecutiveJob && !onboardingCapability && !onboardingPersonalJob;
  const noOnBoarding = !onboarding;

  let tabsType = noOnBoarding ?
    TAB_ITEMS_PROFILE_CASE.NO_ONBOARDING :
    isSimpleOnboarding ? TAB_ITEMS_PROFILE_CASE.SIMPLE_ONBOARDING :
      TAB_ITEMS_PROFILE_CASE.ALL_ONBOARDING as keyof typeof TAB_ITEMS_PROFILE_CASE;


  let tabItems = [...getTabItemsProfileConfig(!!smartConfiguration?.visExternalCertificate)[tabsType].tabItems];


  let tabItemsFiltered = tabItems;

  return tabItemsFiltered.map((tab)=> (
    {
      components:([
        // eslint-disable-next-line react/jsx-key
        <TabsContentProfile
          tabTypeProfile={ tab } learnerAchievements={ learnerAchievements } />
      ]),
      label:getTabLabel({ tabType:tab }),
      type:tab
    })

  );
}

function getTabLabel({
  tabType
} : {
  tabType: TabItemsProfile
}) {
  switch (tabType){
  case TAB_ITEMS_PROFILE.GOALS:
    return "your_achievements";
  case TAB_ITEMS_PROFILE.SECTOR:
    return "your_sector";
  case TAB_ITEMS_PROFILE.KNOWLEDGE:
    return "your_knowledge";
  case TAB_ITEMS_PROFILE.PREFERENCES:
    return "your_preferences";
  case TAB_ITEMS_PROFILE.EXTERNAL_TRAINING:
    return "your_external_training";
  }
}
